import React, { useEffect, useRef } from "react";
import Simple from "../components/ChakraNav";
import "./Home.css";
import Avnish_Kumar_Resume from "../Resume/Avnish_Kumar_Resume.pdf";
import Typed from "typed.js";
import { IconButton, } from "@chakra-ui/react";
import { BsGithub, BsPerson, BsLinkedin } from 'react-icons/bs'
import { Link } from '@chakra-ui/react'
const Home = () => {
  const el = useRef(null);
  useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Full Stack Developer"],
      typeSpeed: 100,
      backSpeed: 60,
      backDelay: 100,
      loop: true,
      showCursor: false,
    });
    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      <Simple />
      <div id="home">
        <div className="intro">
          <img
            className="img"
            src="https://images.unsplash.com/photo-1562813733-b31f71025d54?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80"
            alt="thank you"
            width={"100%"}
          />
          <div className="nameIntro">
            {/* <p className='p-1'> </p> */}
            <h1 className="h-1"> Hi , I am </h1>
            <h1 className="h-2"> Avnish Kumar</h1>
            <span ref={el} className="el" />
            <br />
            <a href={Avnish_Kumar_Resume} download={"Avnish_Kumar_Resume"}>
              <button
                className="ResumeButton"
                onClick={() => {
                  window.open(
                    "https://drive.google.com/file/d/17EazqHpb5BhbDUPezOZv2RYWJUV5zHzj/view?usp=sharing"
                  );
                }}
              >
                Hire me{" "}
              </button>
            </a>
            <br/>
            <Link href='https://github.com/Ashukla011' isExternal>
                     <IconButton
                      aria-label="github"
                      variant="ghost"
                      size="lg"
                      isRound={true}
                      _hover={{ bg: '#0D74FF' }}
                      icon={<BsGithub size="28px" />}
                    />
                     </Link>
                   
                   
                    <Link href="https://www.linkedin.com/in/avnish-kumar-02161922b/" isExternal>
                    <IconButton
                      aria-label="discord"
                      variant="ghost"
                      size="lg"
                      isRound={true}
                      _hover={{ bg: '#0D74FF' }}
                      icon={<BsLinkedin size="28px" />}
                    />
                    </Link>
          </div>

        </div>
      </div>
    </>
  );
};

export default Home;
